import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export const TEXT_KEYS = {
    FAQ_TITLE: 'faq__title',
    FAQ_ACTIONS_EXPAND_ALL: 'faq__actions-expand-all',
    FAQ_ACTIONS_COLLAPSE_ALL: 'faq__actions-collapse-all'
};

export const FAQ_ANALYTICS = (index: string) => ({
    category: CATEGORY.INTERACTION,
    action: `FAQ: ${index}`
});
